import React from 'react';
import { Code, Security, Payment, Webhook } from '@mui/icons-material';

const ExampleTabs = ({ tabs, activeTab, onTabChange }) => {
    const getTabIcon = (tabKey) => {
        const icons = {
            authentication: Security,
            payment: Payment,
            verification: Code,
            webhooks: Webhook
        };
        return icons[tabKey] || Code;
    };

    const getTabColor = (tabKey) => {
        return activeTab === tabKey
            ? 'bg-amber-100 text-amber-700 border-amber-200'
            : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100';
    };

    return (
        <nav className="sticky top-24 bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Catégories</h3>
            <ul className="space-y-2">
                {Object.entries(tabs).map(([key, tab]) => {
                    const IconComponent = getTabIcon(key);
                    return (
                        <li key={key}>
                            <button
                                onClick={() => onTabChange(key)}
                                className={`w-full text-left px-4 py-3 rounded-lg transition-all duration-200 border flex items-center space-x-3 ${getTabColor(key)}`}
                            >
                                <IconComponent className="text-lg" />
                                <span className="font-medium">{tab.title}</span>
                            </button>
                        </li>
                    );
                })}
            </ul>

            {/* Quick Tips */}
            <div className="mt-8 pt-6 border-t border-gray-200">
                <h4 className="text-sm font-semibold text-gray-900 mb-3">Conseils Rapides</h4>
                <ul className="space-y-2 text-sm text-gray-600">
                    <li className="flex items-center space-x-2">
                        <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                        <span>Utilisez toujours HTTPS</span>
                    </li>
                    <li className="flex items-center space-x-2">
                        <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                        <span>Validez les données d'entrée</span>
                    </li>
                    <li className="flex items-center space-x-2">
                        <div className="w-2 h-2 bg-amber-500 rounded-full"></div>
                        <span>Gérez les erreurs</span>
                    </li>
                </ul>
            </div>
        </nav>
    );
};

export default ExampleTabs;